module.exports = __webpack_public_path__ + "img/copy-content-reverse.3fb97bd2.svg";